import { keys } from '@core/Services/Analytics/keys'
import { trackKey } from '@core/Services/Analytics/track'
import type { DisplayLocation } from './types'

export const trackBetSlipButtonClick = () => trackKey(keys.appHeaderBetSlipButtonClick)
export const trackPendingBetsButtonClick = (location: DisplayLocation) =>
  trackKey(location === 'betslip' ? keys.betSlipPendingBetsClick : keys.appHeaderPendingBetsClick)
